import React, { Component } from 'react';
import { Chart } from "react-google-charts";
import asyncWrapper from '../../../../../../shared/javascripts/hocs/asyncWrapper'
import Loading from '../../../../../../shared/javascripts/components/Loading'

import UserProgressApi from '../../../api/UserProgressApi'

class WeeklyScore extends Component {
  constructor(props) {
    super(props)
    this.state = {data: []}
  }

  componentDidMount() {
    UserProgressApi.fetchWeeklyScores(this.props.user.id)
      .then(this.props.handleErrors)
      .then(response => {
        this.setState({data: response},
          ()=>this.props.setLoading()
        )
      }).catch(error => console.log(error))
  }

  render() {
    if(this.props.loading) {return <Loading />}

    return (
      <Chart
        chartType="ComboChart"
        width={'100%'}
        data={this.state.data}
        options={
          {
            title: 'Weekly Score (Last 4 Weeks)',
            chartArea: { width: '60%' },
            hAxis: {
              title: 'Week',
            },
            vAxis: {
              title: 'Percentage(%)',
              minValue: 0,
              maxValue: 100,
              viewWindow: {
                min: 0,
                max: 100
              }
            },
            seriesType: "bars",
            series: {'5': {type: 'line'}}
          }
        }
      />
    );
  }
}

export default asyncWrapper(WeeklyScore)


// WEBPACK FOOTER //
// ./src/reports/google_play/javascripts/components/User/Scores/WeeklyScore.jsx